export default __webpack_public_path__ + "static/media/fdb30eac87cfde8ca2a6396ac0046ba9.jpg";